module.exports = __webpack_public_path__ + "static/media/Inter-ExtraBold.b82eef49.woff";